import { render, staticRenderFns } from "./MetadataBox.vue?vue&type=template&id=75bb0d60&"
import script from "./MetadataBox.vue?vue&type=script&lang=js&"
export * from "./MetadataBox.vue?vue&type=script&lang=js&"
import style0 from "./MetadataBox.vue?vue&type=style&index=0&id=75bb0d60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports